import * as React from 'react';

// @ts-expect-error
import type {FieldArrayProps} from 'redux-form';

import {AttachmentCountReduxForm} from './attachment-count-redux-form';
import {FilestackButton} from './filestack-button';
import type {Props as FilestackButtonProps} from './filestack-button';

type Props = FieldArrayProps;
type HandleUploaded = FilestackButtonProps['handleFilesUploaded'];

export class FileAttachmentForm extends React.PureComponent<Props> {
    render() {
        return (
            <div style={{display: 'flex'}}>
                <FilestackButton
                    handleFilesUploaded={this.handleFilesUploaded}
                    options={{maxSize: 5242880}}
                />
                <AttachmentCountReduxForm attachments={this.props.fields} />
            </div>
        );
    }

    handleFilesUploaded: HandleUploaded = (files) => {
        files.filesUploaded.forEach((file) => {
            this.props.fields.push(file);
        });
    };
}
